import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { AccountoptionsComponent } from './accountoptions.component';
import { EditAccountoptionsComponent } from './edit-accountoptions/edit-accountoptions.component';
import { ReportingGuard } from 'src/app/guards/reporting.guard';


const routes: Routes = [
  {
    path: ':id',
    component: AccountoptionsComponent,
    canActivate: [ReportingGuard]
  },
  {
    path: ':id/edit/:aid',
    component: EditAccountoptionsComponent,
    canActivate: [ReportingGuard]
  },
];

@NgModule({
  declarations: [],
  imports: [
    RouterModule.forChild(routes),
    CommonModule
  ],
  exports: [RouterModule],
})
export class AccountoptionsModule { }
